import {
  Briefcase,
  Building,
  ChefHat,
  Cpu,
  DollarSign,
  Hammer,
  Landmark,
} from "lucide-react";

export const categoryConfig: Record<
  string,
  { icon: any; bg: string; color: string; description: string }
> = {
  architecture: {
    icon: Building,
    bg: "bg-violet-500/10",
    color: "text-violet-600",
    description:
      "Hotel architects and interior designers who understand hospitality",
  },
  "architecture & design": {
    icon: Building,
    bg: "bg-violet-500/10",
    color: "text-violet-600",
    description:
      "Hotel architects and interior designers who understand hospitality",
  },
  technology: {
    icon: Cpu,
    bg: "bg-sky-500/10",
    color: "text-sky-600",
    description: "Booking systems, property management, and channel managers",
  },
  fnb: {
    icon: ChefHat,
    bg: "bg-amber-500/10",
    color: "text-amber-600",
    description: "Menu development, kitchen design, and beverage programs",
  },
  "f&b consultants": {
    icon: ChefHat,
    bg: "bg-amber-500/10",
    color: "text-amber-600",
    description: "Menu development, kitchen design, and beverage programs",
  },
  "f&b": {
    icon: ChefHat,
    bg: "bg-amber-500/10",
    color: "text-amber-600",
    description: "Menu development, kitchen design, and beverage programs",
  },
  operations: {
    icon: Briefcase,
    bg: "bg-emerald-500/10",
    color: "text-emerald-600",
    description: "Pre-opening specialists, revenue management, and training",
  },
  legal: {
    icon: Landmark,
    bg: "bg-rose-500/10",
    color: "text-rose-600",
    description: "Hospitality lawyers, hotel lenders, and accountants",
  },
  "legal & finance": {
    icon: Landmark,
    bg: "bg-rose-500/10",
    color: "text-rose-600",
    description: "Hospitality lawyers, hotel lenders, and accountants",
  },
  development: {
    icon: Hammer,
    bg: "bg-orange-500/10",
    color: "text-orange-600",
    description: "Project managers, contractors, and FF&E procurement",
  },
  "development & construction": {
    icon: Hammer,
    bg: "bg-orange-500/10",
    color: "text-orange-600",
    description: "Project managers, contractors, and FF&E procurement",
  },
  financial: {
    icon: DollarSign,
    bg: "bg-green-500/10",
    color: "text-green-600",
    description: "Financial consultants, investors, and funding specialists",
  },
};

export const partnerCategories = [
  {
    id: "technology",
    title: "Technology",
    aliases: ["technology", "Technology"],
  },
  {
    id: "architecture",
    title: "Architecture & Design",
    aliases: ["architecture", "Architecture & Design", "architecture & design"],
  },
  {
    id: "fnb",
    title: "F&B Consultants",
    aliases: ["fnb", "F&B Consultants", "f&b consultants", "f&b"],
  },
  {
    id: "operations",
    title: "Operations",
    aliases: ["operations", "Operations"],
  },
  {
    id: "legal",
    title: "Legal & Finance",
    aliases: ["legal", "Legal & Finance", "legal & finance"],
  },
  {
    id: "development",
    title: "Development & Construction",
    aliases: [
      "development",
      "Development & Construction",
      "development & construction",
    ],
  },
  { id: "financial", title: "Financial", aliases: ["financial", "Financial"] },
];
